import styled from '@emotion/styled/macro'

const InfoFieldBlock = styled('span')`
  color: var(--CINight);
  font-weight: 400;
  line-height: 1.25rem;
  white-space: pre-line;
  width: 100%;

  > span {
    display: block;

    :not(:last-of-type) {
      margin-bottom: 16px;
    }
  }

  :not(:last-of-type) {
    margin-bottom: 24px;
  }
`

const InfoFieldTitle = styled('p')`
  font-weight: 500;
  margin-bottom: 4px;
`

export { InfoFieldBlock, InfoFieldTitle }
